import { getSiblings, closeSiblingsDropdown } from './utils';

function handleSectorSpecDropdown() {
  const projectFilterForm = document.querySelector('.project-filter-block-form');

  if (!projectFilterForm) return;
  const sectorBox = projectFilterForm.querySelector('.js-form-item-sectors');

  const sectorSelectLabel = document.createElement('label');
  sectorSelectLabel.classList.add('form-item__label');
  sectorSelectLabel.innerText = 'Sector Specialisation';

  const sectorSpecSelect = document.createElement('button');
  sectorSpecSelect.classList.add('button-select');

  const checkedSectors = document.querySelectorAll(
    '.filter-sector-specialisation .js-form-type-checkbox input[checked="checked"]:not([value="all"]) ',
  );

  if (checkedSectors.length > 0) {
    if (checkedSectors.length === 1) {
      sectorSpecSelect.innerText = checkedSectors[0].parentElement.querySelector('label')?.innerText;
    } else {
      sectorSpecSelect.innerText = `${checkedSectors[0].parentElement.querySelector('label')?.innerText} (+ ${
        checkedSectors.length - 1
      })`;
    }
  } else {
    sectorSpecSelect.innerText = 'Select';
  }

  const sectorSpecDropdown = document.createElement('div');
  sectorSpecDropdown.classList.add('sectors-specialisation-dropdown');

  sectorSpecDropdown.appendChild(sectorSelectLabel);
  sectorSpecDropdown.appendChild(sectorSpecSelect);
  sectorBox.after(sectorSpecDropdown);

  const closeButton = document.createElement('button');
  closeButton.classList.add('close-sector-spec');
  closeButton.innerText = '✕';

  closeButton.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();

    projectFilterForm.querySelector('#sector-specialisation-wrapper')?.classList.remove('active');
    sectorSpecSelect.classList.remove('active');
  });

  sectorSpecSelect.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();

    const siblings = getSiblings(projectFilterForm.querySelector('.sector'));
    closeSiblingsDropdown(siblings);

    sectorSpecSelect.classList.toggle('active');
    document.querySelector('.nice-select.open')?.classList.remove('open');

    const sectorSpecBox = projectFilterForm.querySelector('#sector-specialisation-wrapper');

    sectorSpecBox.classList.toggle('active');

    sectorSpecBox.prepend(closeButton);
  });

  function handleDisabled() {
    const sectorSpecFieldset = document.querySelector('.filter-sector-specialisation');

    const isDisabled = sectorSpecFieldset.getAttribute('disabled');

    if (isDisabled) {
      sectorSpecSelect.setAttribute('disabled', 'disabled');
      sectorSelectLabel.style.opacity = 0.3;
    } else {
      sectorSpecSelect.removeAttribute('disabled');
      sectorSelectLabel.style.opacity = 1;
    }
  }

  window.addEventListener('click', (e) => {
    const sectorSpecBox = projectFilterForm.querySelector('#sector-specialisation-wrapper.active');

    if (!sectorSpecBox) return;

    if (sectorSpecBox.isEqualNode(e.target)) {
      return;
    }

    if (e.target.closest('#sector-specialisation-wrapper')?.isEqualNode(sectorSpecBox)) {
      return;
    }
    if (!sectorSpecSelect.isEqualNode(e.target)) {
      sectorSpecBox.classList.remove('active');
      sectorSpecSelect.classList.remove('active');
    }
  });

  function updateDropdownOnCheckboxChange() {
    const checkboxes = document.querySelectorAll(
      '.filter-sector-specialisation .js-form-type-checkbox input:not([value="all"]) ',
    );

    if (!checkboxes.length > 0) return;

    const checkedItems = Array.from(
      document.querySelectorAll(
        '.filter-sector-specialisation .js-form-type-checkbox input[checked="checked"]:not([value="all"]) ',
      ),
    );

    let checkedValues = [];

    checkedItems.forEach((item) => {
      const obj = {
        value: item.value,
        label: item.parentElement.querySelector('label')?.innerText,
      };
      checkedValues.push(obj);
    });

    checkboxes.forEach((checkbox) => {
      checkbox.addEventListener('change', (event) => {
        const obj = {
          value: checkbox.value,
          label: checkbox.parentElement.querySelector('label')?.innerText,
        };
        if (event.currentTarget.checked) {
          checkedValues.push(obj);
        } else {
          checkedValues = checkedValues.filter((item) => item.value !== obj.value);
        }

        // update dropdown text

        if (checkedValues.length > 0) {
          if (checkedValues.length === 1) {
            sectorSpecSelect.innerText = checkedValues[0].label;
          } else {
            sectorSpecSelect.innerText = `${checkedValues[0].label} (+ ${checkedValues.length - 1})`;
          }
        } else {
          sectorSpecSelect.innerText = 'Select';
        }
      });
    });
  }

  updateDropdownOnCheckboxChange();

  (function (Drupal, $) {
    handleDisabled();
    $(document).ajaxComplete(() => {
      sectorSpecSelect.innerText = 'Select';
      handleDisabled();
      updateDropdownOnCheckboxChange();
    });
  })(Drupal, jQuery);
}

function handleMobileProjectFilter() {
  const breakpoint = window.matchMedia('(max-width: 1023px)');
  const btnFilter = document.querySelector('.btn-filter-mobile');
  const btnBack = document.querySelector('.btn-filter-back');
  const filterTagsMobile = document.querySelector('.filter-tags-mobile');
  const filterForm = document.querySelector('.project-filters__form');
  const resetTags = filterForm?.querySelector('.reset-filters');

  function closeFilter() {
    filterForm.classList.remove('active');
    document.body.classList.remove('no-scrollable');
  }

  let btnFilterText = 'Filter projects';

  const filterTagItems = resetTags.querySelectorAll('li');

  if (filterTagItems.length > 1) {
    btnFilterText = `Filter projects (${filterTagItems.length - 1})`;
  }

  btnFilter.innerText = btnFilterText;

  btnFilter.addEventListener('click', () => {
    filterForm.classList.add('active');
    document.body.classList.add('no-scrollable');
  });

  btnBack.addEventListener('click', () => {
    closeFilter();
  });

  filterTagsMobile.appendChild(resetTags.cloneNode(true));

  breakpoint.addEventListener('change', () => {
    if (!breakpoint.matches) {
      closeFilter();
    }
  });
}

window.addEventListener('load', () => {
  const projectFilterBlock = document.querySelector('#block-projectfilters');
  if (!projectFilterBlock) return;
  handleSectorSpecDropdown();
  handleMobileProjectFilter();
});
